/**
 * Created by mukund on 8/25/17.
 */
angular.module('mediacloudApp')
    .directive('lmsErrors', function(){

        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/lms/directives/errors/errors.html',
            scope: {
                errors: '='
            }
        }

    });
